// extracted by mini-css-extract-plugin
module.exports = {"userCard":"styles_userCard__3dkjI","details":"styles_details__3RGLj","img":"styles_img__3N9Qf"};